import $ from "jquery";
// import Swiper JS
import Swiper, { Navigation, Pagination, Scrollbar } from 'swiper';
// import Swiper styles
import 'swiper/swiper-bundle.css';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Scrollbar]);

$('.gallery_b10f').each(function(){
  var $slider = $(this);
  var $slides = $slider.find('.gallery_b10f__slides');
  var $prev = $slider.find('.gallery_b10f__prev');
  var $next = $slider.find('.gallery_b10f__next');

  new Swiper($slides[0], {
    // slidesPerView: 'auto',
    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    // scrollbar: {
    //   el: '.swiper-scrollbar',
    //   hide: false,
    // },
    breakpoints: {
      300: {
        slidesPerView: 1,
      },
      540: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 1,
      },
      1180: {
        slidesPerView: 1,
      }
    },
    // Navigation arrows
    navigation: {
      nextEl: $next[0],
      prevEl: $prev[0],
    }
  });

});


jQuery(document).ready(function($) {
  $('img[title]').each(function() { $(this).removeAttr('title'); });
});